import { render, staticRenderFns } from "./ChimeList.vue?vue&type=template&id=dbd09442&"
import script from "./ChimeList.vue?vue&type=script&lang=js&"
export * from "./ChimeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports